import React from "react";
import MaskedInput from "react-text-mask";
import emailMask from "text-mask-addons/dist/emailMask";

export default function EmailInput(props) {
  return (
    <MaskedInput
      mask={emailMask}
      type="text"
      placeholder="example@domain.com"
      {...props}
    />
  );
}

// import React from "react";
// import MaskedInput from "react-maskedinput";
//
// function EmailInput(props) {
//   return (
//     <MaskedInput
//       mask="XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX"
//       placeholder=""
//       // size="30"
//       {...props}
//       formatCharacters={{
//         X: {
//           validate: char =>
//             /[a-zA-Z\dА-ЕЖ-ЩЬЮЯЇІЄҐа-еж-щьюяїієґ!#$%&'*+-//=?^_`{|}~@]/.test(
//               char
//             )
//           // transform: char => char.toUpperCase()
//         }
//       }}
//     />
//   );
// }

// export default EmailInput;
